export default {
  nationalIdentityCard: "CURP",
  taxIdentificationNumber: "RFC",
  electoralRegistryNumber: "IFE"
}